import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';

export const BaseButton = styled.div.attrs({
    role: 'button',
})`
    width: 75px;
    height: 75px;
    border-radius: 50%;
    background-color: ${colors.red};
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    cursor: pointer;

    @media (${breakpoints.mediumMin}) {
        width: 65px;
        height: 65px;
    }

    @media (${breakpoints.largeMin}) {
        width: 75px;
        height: 75px;
    }
`;
